import { useTranslation } from 'react-i18next'
import { useStoreSelector } from 'hooks/store.ts'
import { formatAddress } from 'utils/user.ts'
import { AddressFormats } from 'types/format.ts'
import styles from '../GuaranteeOfOrigin.module.scss'
import { Banner, Tag } from '@boltenergy-be/design-system'
import { formatContractStatus, isActiveContract } from 'utils/contracts.ts'
import { useState } from 'react'
import ShowInactiveAddresses from 'pages/app/addresses/components/ShowInactiveAddresses.tsx'
import dayjs from 'dayjs'
import { GUARANTEES_OF_ORIGIN_STATUSES } from '@boltenergy-be/shared'

const GuaranteeOfOriginStatus = () => {
  // Redux
  const { billingContracts } = useStoreSelector((store) => store.contact)
  const electricityContracts =
    (!!billingContracts && Object.values(billingContracts).map((billingContract) => billingContract.serviceContracts.electricity)) || []
  const serviceContractsWithGo = electricityContracts.filter(
    (c) => c.detail.goStatus && c.detail.goStatus !== GUARANTEES_OF_ORIGIN_STATUSES.n_a
  )
  const inactiveContracts = serviceContractsWithGo.filter((c) => !isActiveContract(c)).map((c) => c.contractNumber)

  // i18n
  const { t } = useTranslation(['guaranteeOfOrigin', 'addresses'])

  // Local state
  const [showInactive, setShowInactive] = useState<boolean>(inactiveContracts.length === serviceContractsWithGo.length)

  return (
    <>
      {serviceContractsWithGo?.length ? (
        <ul className={styles['go-list']}>
          {serviceContractsWithGo
            .filter((c) => showInactive || isActiveContract(c))
            .map((serviceContract) => {
              const { goStatus } = serviceContract.detail
              const electricityStatus = formatContractStatus(serviceContract)

              return (
                goStatus &&
                goStatus !== GUARANTEES_OF_ORIGIN_STATUSES.n_a && (
                  <li key={serviceContract.contractNumber} className={styles.go}>
                    <strong>{formatAddress(serviceContract.deliveryPoint.address, AddressFormats.STREET_NUMBER_BOX)}</strong>
                    <span>{formatAddress(serviceContract.deliveryPoint.address, AddressFormats.POSTAL_CODE_TOWN)}</span>
                    {inactiveContracts.includes(serviceContract.contractNumber) ? (
                      <Tag size="small" type="neutral" icon="cross">
                        {t(($) => $.overview.status[electricityStatus.key], {
                          ns: 'addresses',
                          date: dayjs(electricityStatus.date).format('D MMMM YYYY')
                        })}
                      </Tag>
                    ) : (
                      <Tag
                        size="small"
                        type={goStatus === GUARANTEES_OF_ORIGIN_STATUSES.confirmed ? 'positive' : 'blocking'}
                        icon={goStatus === GUARANTEES_OF_ORIGIN_STATUSES.confirmed ? 'check' : 'cross'}
                      >
                        {t(($) => $.status.myGoStatus[goStatus])}
                      </Tag>
                    )}
                  </li>
                )
              )
            })}
        </ul>
      ) : (
        <Banner title={t(($) => $.status.noneFound)} />
      )}

      <ShowInactiveAddresses inactiveContractsCount={inactiveContracts.length} {...{ showInactive, setShowInactive }} />
    </>
  )
}

export default GuaranteeOfOriginStatus
